/**
 * @author Javier Ojeda
 * @date 27/11/2018
 * @description : Estilos globales para reutilizarlos en cualquier componente genérico de layout
 */
// @flow

import styled from 'styled-components';
import { media } from 'styles/Mixins';
import { font } from 'styles/Constants';

export const FlexRow = styled.div`
  display: ${({ isVisible = true }) => (isVisible ? 'flex' : 'none')};
  flex-direction: row;
  align-items: ${({ alignItems = 'normal' }) => alignItems};
  justify-content: ${({ justifyContent = 'normal' }) => justifyContent};
`;

export const FlexColumn = styled.div`
  display: ${({ isVisible = true }) => (isVisible ? 'flex' : 'none')};
  flex-direction: column;
  align-items: ${({ alignItems = 'normal' }) => alignItems};
  justify-content: ${({ justifyContent = 'normal' }) => justifyContent};
`;

export const GeneralContainer = styled.div`
  padding: 10px;
  padding-bottom: 15px;
  border-radius: 2px;
  background-color: #fff;
  width: calc(100% - 10px);
  margin: 0 auto 10px auto;
  ${media.md`
    padding: 15px;
    width: 100%;
  `}
`;

export const Spacer = styled.div`
  flex-basis: 0;
  flex-grow: 1;
`;

export const UbicationPlace = styled.div`
  padding: 10px;
  padding-bottom: 15px;
  border-radius: 2px;
  background-color: #fff;
  width: 100%;
  display: none;
  margin-top: 5px;
  margin-bottom: 5px;
  font-family: ${font.openSans};
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  color: #4a4a4a;
  ${media.md`
    padding: 15px;
    width: 100%;
    display: none;
  `}
`;

export const UbicationNearColonies = styled.div`
  padding: 10px;
  padding-bottom: 15px;
  border-radius: 2px;
  background-color: #fff;
  width: 100%;
  margin: 0 auto 15px auto;
  font-family: ${font.openSans};
  font-size: 16px;
  line-height: 19px;
  color: #4a4a4a;
  ${media.md`
    padding: 15px;
    width: 100%;
    float: left;
    background:none;
  `}
`;

export const UbicationContent = styled.div`
  padding: 10px;
  padding-bottom: 15px;
  border-radius: 2px;
  background-color: #fff;
  width: 100%;
  ${media.md`
    padding: 15px;
    width: 100%;
    background-color: #fafafa;
  `}
`;

export const GeneralContainerTitle = styled.p`
  color: #4a4a4a;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.25px;
  margin-bottom: 12px;
  ${media.md`
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.4px;
  `}
`;

export const RelativeContainer = styled.div`
  position: relative;
  width: 100%;
`;
